export const NAME_SPACES = {
  HOME: "home",
  GENERIC: "generic",
  PRIVATE: {
    BROKER: {
      CLIENT: "broker.client",
      CONTRACT: "broker.contract",
      CONTACT: "broker.contact",
      ORGANIZATION: "broker.organization",
      PROJECT: "broker.project",
      USER: "broker.user",
      REMINDER: "broker.reminder",
      QUALIFICATION: "broker.qualification",
      NOTE: "broker.note",
      COLLABORATOR: "broker.collaborator",
      SUBSCRIPTION: "broker.subscription",
      DASHBOARD: "broker.dashboard",
      NOTIFICATION: "broker.notification",
      TASK: "broker.task",
    },
    ADMIN: {
      DASHBOARD: "admin.dashboard",
      SOURCE: "admin.source",
      COLLABORATOR: "admin.collaborator",
      TRACER: "admin.tracer",
      FLOW: "admin.flow",
      PROCESS: "admin.process",
      USER: "admin.user",
      INSURANCE_PLAN: "admin.insurance.plan",
      COVERAGE: "admin.coverage",
      COVERAGE_BENEFIT: "admin.coverage.benefit",
      QUALIFIER: "admin.qualifier",
      QUALIFICATION: "admin.qualification",
      WEBHOOK: "admin.webhook",
      BROKER: "admin.broker",
      COMPANY: "admin.company",
      WORKFLOW: "admin.workflow",
      PRICER: "admin.pricer",
      COMMISSION_STATEMENT: "admin.commission.statement",
      COMMISSION: "admin.commission",
      COVERAGE_CATEGORY: "admin.coverage.category",
      ORGANIZATION: "admin.organization",
      OFFER: "admin.offer",
      TEMPLATE: "admin.template",
      BRAND: "admin.brand",
      STORE: "admin.store",
    },
  },
  PUBLIC: {
    CONTACT: "contact",
    PROCESSES: "Processes",
  },
  ERRORS: "errors",
  AUTH: "auth",
  BREADCRUMB: "breadcrumb",
  COMPONENTS: "components",
};
